import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { PwaPushNotificationsUserSettings } from '../../../services/pwa-push-notification/pwa-push-notifications-user-settings.type';
import { LoadStatus } from '../../load-status';
import {
    PWA_PUSH_NOTIFICATION_FEATURE_KEY,
    PushSubscriptionHealth,
    PwaPushNotificationState,
} from '../pwa-push-notification.state';

export const selectPwaPushNotificationFeature = createFeatureSelector<PwaPushNotificationState>(
    PWA_PUSH_NOTIFICATION_FEATURE_KEY,
);

/** The persisted subscription choice, or `undefined` for a first-time user. */
export const selectPwaPushNotificationSettings: MemoizedSelector<object, PwaPushNotificationsUserSettings | undefined> =
    createSelector(selectPwaPushNotificationFeature, (state) => state.settings);

/** Raw load status of the slice. */
export const selectPwaPushNotificationStatus: MemoizedSelector<object, LoadStatus> = createSelector(
    selectPwaPushNotificationFeature,
    (state) => state.status,
);

/** Whether the settings have settled (read from storage, successfully or not). */
export const selectPwaPushNotificationSettled: MemoizedSelector<object, boolean> = createSelector(
    selectPwaPushNotificationStatus,
    (status) => status === LoadStatus.Loaded || status === LoadStatus.Error,
);

/** Whether the user is currently subscribed to push notifications. */
export const selectIsUserSubscribedToPushNotifications: MemoizedSelector<object, boolean> = createSelector(
    selectPwaPushNotificationSettings,
    (settings) => settings?.isUserSubscribed ?? false,
);

/** Live subscription health: subscribed, renewing, not subscribed, or not yet checked. */
export const selectPwaPushNotificationSubscriptionHealth: MemoizedSelector<object, PushSubscriptionHealth> =
    createSelector(selectPwaPushNotificationFeature, (state) => state.subscriptionHealth);
